export default {
  language_picker_helper: "Velg et språk",
  languages: {
    english: "Engelsk",
    swedish: "Svenska"
  },
  chooseQuantities: "Välj kvantiteter",
};
